import styled from 'styled-components';

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  white-space: nowrap;
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const StepLabel = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 8px;
  column-gap: 8px;

  border-radius: 4px;
  background-color: ${({ isActive, activeBackgroundColor }) =>
    isActive ? activeBackgroundColor : 'transparent'};
`;

export const StepIcon = styled.div`
  height: 16px;
  min-width: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${({ theme }) => theme.colors.greys.lightest};
  font: ${({ theme }) => theme.fonts.textMicroWidth8Height16Weight700Bold};

  border-radius: 50%;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.greys.darkest : theme.colors.greys.dark};
`;
